import { render } from "./congratulationsView.vue?vue&type=template&id=a0531b98&scoped=true"
import script from "./congratulationsView.vue?vue&type=script&lang=js"
export * from "./congratulationsView.vue?vue&type=script&lang=js"

import "./congratulationsView.vue?vue&type=style&index=0&id=a0531b98&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0531b98"]])

export default __exports__